import * as React from "react"
import * as TabsPrimitive from "@radix-ui/react-tabs"

import { cn } from "@/helpers/classNames"

const Tabs = TabsPrimitive.Root

function TabsList({
  className,
  ref,
  ...props
}: {
  ref?: React.Ref<React.ElementRef<typeof TabsPrimitive.List>>
} & React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>) {
  return (
    <TabsPrimitive.List
      ref={ref}
      className={cn(
        "inline-flex w-full items-center border-b border-neutral-400",
        className,
      )}
      {...props}
    />
  )
}

function TabsTrigger({
  className,
  ref,
  ...props
}: {
  ref?: React.Ref<React.ElementRef<typeof TabsPrimitive.Trigger>>
} & React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>) {
  return (
    <TabsPrimitive.Trigger
      ref={ref}
      className={cn([
        `
          inline-flex items-center justify-center px-6 py-3 whitespace-nowrap
          transition-all
        `,
        `
          border-b-2 border-background
          data-[state=active]:border-primary-300
        `,
        `
          font-button-medium text-neutral-600
          data-[state=active]:text-primary-300
        `,
        "disabled:pointer-events-none disabled:opacity-50",
        `
          ring-offset-background
          focus-visible:ring-2 focus-visible:ring-ring
          focus-visible:ring-offset-2 focus-visible:outline-hidden
        `,
        className,
      ])}
      {...props}
      data-unmask
    />
  )
}

function TabsContent({
  className,
  ref,
  ...props
}: {
  ref?: React.Ref<React.ElementRef<typeof TabsPrimitive.Content>>
} & React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>) {
  return (
    <TabsPrimitive.Content
      ref={ref}
      className={cn(
        `
          mt-1 w-full ring-offset-background
          focus-visible:ring-2 focus-visible:ring-ring
          focus-visible:ring-offset-2 focus-visible:outline-hidden
        `,
        className,
      )}
      {...props}
    />
  )
}

export { Tabs, TabsContent, TabsList, TabsTrigger }
